import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { ContentCategoryDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface ContentCategoryFormProps {
  initialValues: ContentCategoryDTO;
  onSubmit: (data: ContentCategoryDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const ContentCategoryForm: React.FC<ContentCategoryFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<ContentCategoryDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    title: [
      { required: true, message: 'Title is required' }
    ],
    displayPosition: [
      { required: true, message: 'Display Position is required' },
      { custom: (value) => Number(value) >= 0, message: 'Display Position must be a positive number' }
    ]
            };

  const { errors, validate } = useFormValidation<ContentCategoryDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection 
        id={FORM_SECTIONS.basicInfo.id} 
        title={FORM_SECTIONS.basicInfo.title}
      >
                <FormField
          id="title"
          label="Title"
          type="text"
          value={formData.title || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Title"
          required={true}
          error={errors.title}
        />
        <FormField
          id="displayPosition"
          label="Display Position"
          type="number"
          value={formData.displayPosition || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Display Position"
          required={true}
          error={errors.displayPosition}
        />
        <FormField
          id="isActive"
          label="Is Active"
          type="checkbox"
          value={formData.isActive || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Is Active"
          required={false}
          error={errors.isActive}
        />

      </FormSection>
    </Form>
  );
};

export default ContentCategoryForm;